import { ReactNode } from "react";

type Props = {
  title: string;
  body: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: ReactNode;
};

export function RecommendationCard({ title, body, actionLabel, onAction, icon }: Props) {
  return (
    <article className="manager-card">
      <div className="flex items-start gap-2">
        <div className="mt-0.5">{icon || <span aria-hidden="true">!</span>}</div>
        <div className="min-w-0">
          <h3 className="font-semibold text-slate-800">{title}</h3>
          <p className="text-sm text-slate-600 mt-1">{body}</p>
        </div>
      </div>
      {actionLabel && onAction ? (
        <button className="btn secondary mt-3" onClick={onAction}>
          {actionLabel}
        </button>
      ) : null}
    </article>
  );
}
